export default "__VITE_ASSET__CX_2vrnz__"